module.exports = __webpack_public_path__ + "static/img/business2.ec78eaa.png";


//////////////////
// WEBPACK FOOTER
// ./static/aboutUs/business2.png
// module id = dG13
// module chunks = 1